import type { IErrorType } from '../../constants/types';

export const types = {
    FETCH_HOME_STATS: 'brandOps/FETCH_HOME_STATS',
    FETCH_HOME_STATS_SUCCESS: 'brandOps/FETCH_HOME_STATS_SUCCESS',

    FETCH_ACCESS: 'brandOps/FETCH_ACCESS',
    FETCH_ACCESS_SUCCESS: 'brandOps/FETCH_ACCESS_SUCCESS',
    FETCH_ACCESS_FAIL: 'brandOps/FETCH_ACCESS_FAIL',

    FETCH_TEAM: 'brandOps/FETCH_TEAM',
    FETCH_TEAM_SUCCESS: 'brandOps/FETCH_TEAM_SUCCESS',
    FETCH_TEAM_FAIL: 'brandOps/FETCH_TEAM_FAIL',

    INVITE_TEAM: 'brandOps/INVITE_TEAM',
    INVITE_TEAM_SUCCESS: 'brandOps/INVITE_TEAM_SUCCESS',
    INVITE_TEAM_FAIL: 'brandOps/INVITE_TEAM_FAIL',

    UPDATE_TEAM_MEMBER: 'brandOps/UPDATE_TEAM_MEMBER',
    UPDATE_TEAM_MEMBER_SUCCESS: 'brandOps/UPDATE_TEAM_MEMBER_SUCCESS',
    UPDATE_TEAM_MEMBER_FAIL: 'brandOps/UPDATE_TEAM_MEMBER_FAIL',

    REMOVE_TEAM_MEMBER: 'brandOps/REMOVE_TEAM_MEMBER',
    REMOVE_TEAM_MEMBER_SUCCESS: 'brandOps/REMOVE_TEAM_MEMBER_SUCCESS',
    REMOVE_TEAM_MEMBER_FAIL: 'brandOps/REMOVE_TEAM_MEMBER_FAIL',

    ACCEPT_TEAM_INVITE: 'brandOps/ACCEPT_TEAM_INVITE',
    ACCEPT_TEAM_INVITE_SUCCESS: 'brandOps/ACCEPT_TEAM_INVITE_SUCCESS',
    ACCEPT_TEAM_INVITE_FAIL: 'brandOps/ACCEPT_TEAM_INVITE_FAIL',

    FETCH_CONTRACTS: 'brandOps/FETCH_CONTRACTS',
    FETCH_CONTRACTS_SUCCESS: 'brandOps/FETCH_CONTRACTS_SUCCESS',
    FETCH_CONTRACTS_FAIL: 'brandOps/FETCH_CONTRACTS_FAIL',

    CREATE_CONTRACT: 'brandOps/CREATE_CONTRACT',
    CREATE_CONTRACT_SUCCESS: 'brandOps/CREATE_CONTRACT_SUCCESS',
    CREATE_CONTRACT_FAIL: 'brandOps/CREATE_CONTRACT_FAIL',

    GET_CONTRACT: 'brandOps/GET_CONTRACT',
    GET_CONTRACT_SUCCESS: 'brandOps/GET_CONTRACT_SUCCESS',
    GET_CONTRACT_FAIL: 'brandOps/GET_CONTRACT_FAIL',

    DISPATCH_CONTRACT: 'brandOps/DISPATCH_CONTRACT',
    DISPATCH_CONTRACT_SUCCESS: 'brandOps/DISPATCH_CONTRACT_SUCCESS',
    DISPATCH_CONTRACT_FAIL: 'brandOps/DISPATCH_CONTRACT_FAIL',

    SIGN_CONTRACT: 'brandOps/SIGN_CONTRACT',
    SIGN_CONTRACT_SUCCESS: 'brandOps/SIGN_CONTRACT_SUCCESS',
    SIGN_CONTRACT_FAIL: 'brandOps/SIGN_CONTRACT_FAIL',

    FETCH_CALENDAR: 'brandOps/FETCH_CALENDAR',
    FETCH_CALENDAR_SUCCESS: 'brandOps/FETCH_CALENDAR_SUCCESS',
    FETCH_CALENDAR_FAIL: 'brandOps/FETCH_CALENDAR_FAIL',

    CREATE_CALENDAR_ITEM: 'brandOps/CREATE_CALENDAR_ITEM',
    CREATE_CALENDAR_ITEM_SUCCESS: 'brandOps/CREATE_CALENDAR_ITEM_SUCCESS',
    CREATE_CALENDAR_ITEM_FAIL: 'brandOps/CREATE_CALENDAR_ITEM_FAIL',

    UPDATE_CALENDAR_ITEM: 'brandOps/UPDATE_CALENDAR_ITEM',
    UPDATE_CALENDAR_ITEM_SUCCESS: 'brandOps/UPDATE_CALENDAR_ITEM_SUCCESS',
    UPDATE_CALENDAR_ITEM_FAIL: 'brandOps/UPDATE_CALENDAR_ITEM_FAIL',

    APPROVE_CALENDAR_ITEM: 'brandOps/APPROVE_CALENDAR_ITEM',
    APPROVE_CALENDAR_ITEM_SUCCESS: 'brandOps/APPROVE_CALENDAR_ITEM_SUCCESS',
    APPROVE_CALENDAR_ITEM_FAIL: 'brandOps/APPROVE_CALENDAR_ITEM_FAIL',

    PUBLISH_CALENDAR_ITEM: 'brandOps/PUBLISH_CALENDAR_ITEM',
    PUBLISH_CALENDAR_ITEM_SUCCESS: 'brandOps/PUBLISH_CALENDAR_ITEM_SUCCESS',
    PUBLISH_CALENDAR_ITEM_FAIL: 'brandOps/PUBLISH_CALENDAR_ITEM_FAIL',

    FETCH_SETTINGS: 'brandOps/FETCH_SETTINGS',
    FETCH_SETTINGS_SUCCESS: 'brandOps/FETCH_SETTINGS_SUCCESS',
    FETCH_SETTINGS_FAIL: 'brandOps/FETCH_SETTINGS_FAIL',

    UPDATE_SETTINGS: 'brandOps/UPDATE_SETTINGS',
    UPDATE_SETTINGS_SUCCESS: 'brandOps/UPDATE_SETTINGS_SUCCESS',
    UPDATE_SETTINGS_FAIL: 'brandOps/UPDATE_SETTINGS_FAIL',

    DOWNLOAD_CONTRACT_PDF: 'brandOps/DOWNLOAD_CONTRACT_PDF',
    DOWNLOAD_CONTRACT_PDF_SUCCESS: 'brandOps/DOWNLOAD_CONTRACT_PDF_SUCCESS',
    DOWNLOAD_CONTRACT_PDF_FAIL: 'brandOps/DOWNLOAD_CONTRACT_PDF_FAIL',

    FETCH_KNOWLEDGE: 'brandOps/FETCH_KNOWLEDGE',
    FETCH_KNOWLEDGE_SUCCESS: 'brandOps/FETCH_KNOWLEDGE_SUCCESS',
    FETCH_KNOWLEDGE_FAIL: 'brandOps/FETCH_KNOWLEDGE_FAIL',

    ADD_KNOWLEDGE: 'brandOps/ADD_KNOWLEDGE',
    ADD_KNOWLEDGE_SUCCESS: 'brandOps/ADD_KNOWLEDGE_SUCCESS',
    ADD_KNOWLEDGE_FAIL: 'brandOps/ADD_KNOWLEDGE_FAIL',

    REMOVE_KNOWLEDGE: 'brandOps/REMOVE_KNOWLEDGE',
    REMOVE_KNOWLEDGE_SUCCESS: 'brandOps/REMOVE_KNOWLEDGE_SUCCESS',
    REMOVE_KNOWLEDGE_FAIL: 'brandOps/REMOVE_KNOWLEDGE_FAIL',

    AI_PLAYGROUND: 'brandOps/AI_PLAYGROUND',
    AI_PLAYGROUND_SUCCESS: 'brandOps/AI_PLAYGROUND_SUCCESS',
    AI_PLAYGROUND_FAIL: 'brandOps/AI_PLAYGROUND_FAIL',

    FETCH_INBOX: 'brandOps/FETCH_INBOX',
    FETCH_INBOX_SUCCESS: 'brandOps/FETCH_INBOX_SUCCESS',
    FETCH_INBOX_FAIL: 'brandOps/FETCH_INBOX_FAIL',

    FETCH_INBOX_STATUS: 'brandOps/FETCH_INBOX_STATUS',
    FETCH_INBOX_STATUS_SUCCESS: 'brandOps/FETCH_INBOX_STATUS_SUCCESS',
    FETCH_INBOX_STATUS_FAIL: 'brandOps/FETCH_INBOX_STATUS_FAIL',

    LOCK_ESCROW: 'brandOps/LOCK_ESCROW',
    LOCK_ESCROW_SUCCESS: 'brandOps/LOCK_ESCROW_SUCCESS',
    LOCK_ESCROW_FAIL: 'brandOps/LOCK_ESCROW_FAIL',

    PAYOUT_ESCROW: 'brandOps/PAYOUT_ESCROW',
    PAYOUT_ESCROW_SUCCESS: 'brandOps/PAYOUT_ESCROW_SUCCESS',
    PAYOUT_ESCROW_FAIL: 'brandOps/PAYOUT_ESCROW_FAIL',

    RELEASE_ESCROW: 'brandOps/RELEASE_ESCROW',
    RELEASE_ESCROW_SUCCESS: 'brandOps/RELEASE_ESCROW_SUCCESS',
    RELEASE_ESCROW_FAIL: 'brandOps/RELEASE_ESCROW_FAIL',

    ADD_STRIKE: 'brandOps/ADD_STRIKE',
    ADD_STRIKE_SUCCESS: 'brandOps/ADD_STRIKE_SUCCESS',
    ADD_STRIKE_FAIL: 'brandOps/ADD_STRIKE_FAIL',

    FETCH_CONVERSATIONS: 'brandOps/FETCH_CONVERSATIONS',
    FETCH_CONVERSATIONS_SUCCESS: 'brandOps/FETCH_CONVERSATIONS_SUCCESS',
    FETCH_CONVERSATIONS_FAIL: 'brandOps/FETCH_CONVERSATIONS_FAIL',

    FETCH_CONVERSATION_MESSAGES: 'brandOps/FETCH_CONVERSATION_MESSAGES',
    FETCH_CONVERSATION_MESSAGES_SUCCESS: 'brandOps/FETCH_CONVERSATION_MESSAGES_SUCCESS',
    FETCH_CONVERSATION_MESSAGES_FAIL: 'brandOps/FETCH_CONVERSATION_MESSAGES_FAIL',

    SEND_INBOX_MESSAGE: 'brandOps/SEND_INBOX_MESSAGE',
    SEND_INBOX_MESSAGE_SUCCESS: 'brandOps/SEND_INBOX_MESSAGE_SUCCESS',
    SEND_INBOX_MESSAGE_FAIL: 'brandOps/SEND_INBOX_MESSAGE_FAIL',

    FETCH_UGC_ASSETS: 'brandOps/FETCH_UGC_ASSETS',
    FETCH_UGC_ASSETS_SUCCESS: 'brandOps/FETCH_UGC_ASSETS_SUCCESS',
    FETCH_UGC_ASSETS_FAIL: 'brandOps/FETCH_UGC_ASSETS_FAIL',

    FETCH_MY_MEMBERSHIPS: 'brandOps/FETCH_MY_MEMBERSHIPS',
    FETCH_MY_MEMBERSHIPS_SUCCESS: 'brandOps/FETCH_MY_MEMBERSHIPS_SUCCESS',
    FETCH_MY_MEMBERSHIPS_FAIL: 'brandOps/FETCH_MY_MEMBERSHIPS_FAIL',

    FETCH_MY_CONTRACT: 'brandOps/FETCH_MY_CONTRACT',
    FETCH_MY_CONTRACT_SUCCESS: 'brandOps/FETCH_MY_CONTRACT_SUCCESS',
    FETCH_MY_CONTRACT_FAIL: 'brandOps/FETCH_MY_CONTRACT_FAIL',

    RESEND_TEAM_INVITE: 'brandOps/RESEND_TEAM_INVITE',
    RESEND_TEAM_INVITE_SUCCESS: 'brandOps/RESEND_TEAM_INVITE_SUCCESS',
    RESEND_TEAM_INVITE_FAIL: 'brandOps/RESEND_TEAM_INVITE_FAIL',

    RENEW_CONTRACT: 'brandOps/RENEW_CONTRACT',
    RENEW_CONTRACT_SUCCESS: 'brandOps/RENEW_CONTRACT_SUCCESS',
    RENEW_CONTRACT_FAIL: 'brandOps/RENEW_CONTRACT_FAIL',

    FREEZE_CONTRACT: 'brandOps/FREEZE_CONTRACT',
    FREEZE_CONTRACT_SUCCESS: 'brandOps/FREEZE_CONTRACT_SUCCESS',
    FREEZE_CONTRACT_FAIL: 'brandOps/FREEZE_CONTRACT_FAIL',

    VOID_CONTRACT: 'brandOps/VOID_CONTRACT',
    VOID_CONTRACT_SUCCESS: 'brandOps/VOID_CONTRACT_SUCCESS',
    VOID_CONTRACT_FAIL: 'brandOps/VOID_CONTRACT_FAIL',

    APPROVE_CONTRACT: 'brandOps/APPROVE_CONTRACT',
    APPROVE_CONTRACT_SUCCESS: 'brandOps/APPROVE_CONTRACT_SUCCESS',
    APPROVE_CONTRACT_FAIL: 'brandOps/APPROVE_CONTRACT_FAIL',

    GET_CONTRACT_FOR_REVIEW: 'brandOps/GET_CONTRACT_FOR_REVIEW',
    GET_CONTRACT_FOR_REVIEW_SUCCESS: 'brandOps/GET_CONTRACT_FOR_REVIEW_SUCCESS',
    GET_CONTRACT_FOR_REVIEW_FAIL: 'brandOps/GET_CONTRACT_FOR_REVIEW_FAIL',

    FETCH_AUTOMATIONS: 'brandOps/FETCH_AUTOMATIONS',
    FETCH_AUTOMATIONS_SUCCESS: 'brandOps/FETCH_AUTOMATIONS_SUCCESS',
    FETCH_AUTOMATIONS_FAIL: 'brandOps/FETCH_AUTOMATIONS_FAIL',

    UPSERT_AUTOMATION: 'brandOps/UPSERT_AUTOMATION',
    UPSERT_AUTOMATION_SUCCESS: 'brandOps/UPSERT_AUTOMATION_SUCCESS',
    UPSERT_AUTOMATION_FAIL: 'brandOps/UPSERT_AUTOMATION_FAIL',

    TOGGLE_AUTOMATION: 'brandOps/TOGGLE_AUTOMATION',
    TOGGLE_AUTOMATION_SUCCESS: 'brandOps/TOGGLE_AUTOMATION_SUCCESS',
    TOGGLE_AUTOMATION_FAIL: 'brandOps/TOGGLE_AUTOMATION_FAIL',

    DELETE_AUTOMATION: 'brandOps/DELETE_AUTOMATION',
    DELETE_AUTOMATION_SUCCESS: 'brandOps/DELETE_AUTOMATION_SUCCESS',
    DELETE_AUTOMATION_FAIL: 'brandOps/DELETE_AUTOMATION_FAIL',

    FETCH_CONTRACT_CLARIFICATIONS: 'brandOps/FETCH_CONTRACT_CLARIFICATIONS',
    FETCH_CONTRACT_CLARIFICATIONS_SUCCESS: 'brandOps/FETCH_CONTRACT_CLARIFICATIONS_SUCCESS',
    FETCH_CONTRACT_CLARIFICATIONS_FAIL: 'brandOps/FETCH_CONTRACT_CLARIFICATIONS_FAIL',
    REPLY_TO_CLARIFICATION: 'brandOps/REPLY_TO_CLARIFICATION',
    REPLY_TO_CLARIFICATION_SUCCESS: 'brandOps/REPLY_TO_CLARIFICATION_SUCCESS',
    REPLY_TO_CLARIFICATION_FAIL: 'brandOps/REPLY_TO_CLARIFICATION_FAIL',
    BRAND_OPS_NEW_CLARIFICATION: 'brandOps/BRAND_OPS_NEW_CLARIFICATION',
    BRAND_OPS_CONTRACT_SIGNED: 'brandOps/BRAND_OPS_CONTRACT_SIGNED',
    BRAND_OPS_CONTRACT_DECLINED: 'brandOps/BRAND_OPS_CONTRACT_DECLINED',
    BRAND_OPS_NEW_DM: 'brandOps/BRAND_OPS_NEW_DM',
} as const;

/** A brand the calling user is an active team member of (returned by GET /brand-ops/team/mine) */
export interface IBrandMembership {
    _id: string;
    name?: string;
    logo?: string;
    feature_image?: string;
    industry?: string;
    industry_vertical?: string;
    role: BrandOpsRole;
    member_id: string;
}

/** Matches Boxofix brand-ops roles */
export type BrandOpsRole = 'content_ops_manager' | 'content_strategist' | 'brand_admin' | 'viewer';

export type BrandOpsContractStatus =
    | 'draft'
    | 'pending_signature'
    | 'signed'
    | 'active'
    | 'void'
    | 'voided'
    | 'ended'
    | 'expired'
    | 'awaiting_brand_approval';

export type BrandOpsCalendarStatus =
    | 'draft'
    | 'pending_approval'
    | 'approved'
    | 'scheduled'
    | 'published'
    | 'rejected'
    | 'missed'
    | 'failed';

export interface IBrandOpsAccess {
    can_access: boolean;
    has_content_manager: boolean;
    role?: BrandOpsRole | null;
    is_brand_admin?: boolean;
    /** Hide wallet / payroll CTAs for non-admin managers */
    can_manage_wallet?: boolean;
    can_manage_payroll?: boolean;
    message?: string | null;
}

export interface IBrandOpsTeamMember {
    _id: string;
    email: string;
    role: BrandOpsRole;
    status: 'pending' | 'active' | 'removed';
    user?: { _id?: string; userName?: string; profile_picture?: string; firstName?: string; lastName?: string } | null;
    invited_at?: string;
    accepted_at?: string | null;
    contract?: { fee?: number; currency?: string; cadence?: string } | null;
}

export interface IBrandOpsContract {
    _id: string;
    title?: string;
    status: BrandOpsContractStatus;
    fee?: number;
    currency?: string;
    cadence?: string;
    deliverables?: string;
    missed_post_threshold?: number;
    max_response_minutes?: number | null;
    clearance_scopes?: string[];
    require_brand_approval?: boolean;
    manager_email?: string;
    manager_name?: string;
    signed_at?: string | null;
    void_at?: string | null;
    /** Backend lifecycle: active | payment_grace | paused | voided | … */
    internal_status?: string | null;
    paused_at?: string | null;
    pause_reason?: string | null;
    payment_grace_until?: string | null;
    strikes?: { count?: number; history?: Array<{ at: string; reason?: string }> };
    escrow_periods?: Array<{
        _id?: string;
        label?: string;
        period_start?: string;
        period_end?: string;
        amount?: number;
        status?: string;
        due_at?: string;
        usd_cents?: number;
        amount_cents?: number;
        currency?: string;
        failure_reason?: string | null;
        payout_usd_cents?: number | null;
        payout_contract_amount_cents?: number | null;
        payout_contract_currency?: string | null;
    }>;
    legal_preview?: string;
    signature?: { typed_name?: string; image_data_url?: string; signed_at?: string };
    duration_periods?: number | null;
    periods_completed?: number;
    createdAt?: string;
    updatedAt?: string;
}

export interface IBrandOpsCalendarItem {
    _id: string;
    title?: string;
    caption?: string;
    status: BrandOpsCalendarStatus;
    scheduled_at?: string | null;
    platform?: string;
    aspect_ratio?: '4:5' | '1:1' | '9:16';
    media_urls?: string[];
    media_type?: 'image' | 'carousel' | 'video';
    /** image | carousel | reel | tiktok_video | yt_video | yt_short */
    format?: string;
    description?: string;
    hashtags?: string[];
    platform_options?: Record<string, unknown>;
    project_id?: string;
    contract?: string | null;
    assigned_manager?: string | null;
    internal_status?: string | null;
    /** SocialPost._id linked after publishCalendarItem — used for automation rules */
    social_post?: string | null;
    createdAt?: string;
    updatedAt?: string;
}

export interface IBrandOpsSettings {
    require_brand_approval?: boolean;
    notify_on_publish?: boolean;
    default_currency?: string;
    autonomy_level?: 'approval_required' | 'supervised' | 'autonomous';
    role_permissions?: Record<string, string[]> | null;
    ai_dm_auto_reply_enabled?: boolean;
    ai_dm_reply_delay_seconds?: number;
    [key: string]: unknown;
}

export interface IBrandOpsKnowledgeDoc {
    _id: string;
    title: string;
    file_key?: string | null;
    public_url?: string | null;
    mime_type?: string | null;
    text_excerpt?: string | null;
    status: 'pending' | 'processing' | 'ready' | 'failed';
    token_estimate?: number;
    error_message?: string | null;
    createdAt?: string;
    updatedAt?: string;
}

export interface IBrandOpsAiPlaygroundResult {
    configured: boolean;
    /** Null when AI is unavailable / human-only — never render as content */
    reply: string | null;
    human_only?: boolean;
    message?: string;
    confidence?: number;
    latency_ms?: number;
    token_count?: number;
    trained_tokens?: number;
    docs_count?: number;
    formatted_for?: string;
    suggested_instagram_dm?: { text?: string; cta?: string | null };
}

export interface IBrandOpsInboxItem {
    _id: string;
    ig_comment_id?: string;
    ig_media_id?: string;
    automation_id?: string;
    social_post_id?: string | null;
    public_reply_sent?: boolean;
    private_reply_sent?: boolean;
    error_message?: string | null;
    trigger_word?: string | null;
    automation_status?: string | null;
    createdAt?: string;
}

export interface IBrandOpsInboxStatus {
    connected?: boolean;
    messaging_ready?: boolean;
    reason?: string;
    has_page_token?: boolean;
    ig_user_id?: string;
    facebook_page_id?: string;
}

export interface IBrandOpsConversation {
    id: string;
    updated_at?: string | null;
    participants?: Array<{ id?: string; name?: string }>;
    peer_id?: string | null;
    peer_name?: string | null;
    peer_profile_pic?: string | null;
    last_message?: {
        id?: string;
        text?: string;
        from_id?: string;
        created_at?: string;
        has_media?: boolean;
        is_sticker?: boolean;
        attachments?: any[];
    } | null;
    unread_hint?: boolean;
}

export interface IBrandOpsInboxMessage {
    id: string;
    text?: string;
    from_id?: string;
    from_name?: string | null;
    created_at?: string;
    attachments?: Array<{ type: 'image' | 'video' | 'file'; url: string }>;
    /** True when the message contains media but attachment URLs are unavailable (Meta Advanced Access not granted). */
    has_media?: boolean;
}

export interface IBrandOpsAutomationRule {
    social_post_id: string;
    ig_media_id?: string | null;
    caption?: string | null;
    scheduled_at?: string | null;
    platform?: string;
    post_status?: string | null;
    automation: {
        _id: string;
        enabled: boolean;
        status: 'pending_publish' | 'active' | 'paused' | 'disabled';
        trigger_word: string | null;
        dm_message: string;
        public_reply_text: string;
        stats?: { comments_handled?: number; last_handled_at?: string | null };
    };
}

export interface IBrandOpsUgcAsset {
    _id: string;
    campaign_id?: string;
    campaign_title?: string;
    submission_id?: string;
    project_id?: string | null;
    file_key?: string | null;
    preview_url?: string | null;
    title?: string | null;
    is_paid?: boolean;
    media_type?: string | null;
    deliverable_type?: string | null;
    status?: string | null;
    participant_id?: string | null;
    /** ISO date when the submission was approved — anchor for license window. */
    approved_at?: string | null;
    /** True when the campaign granted exclusive commercial rights (12 months from approval). */
    exclusive_rights?: boolean;
    /** ISO date when the exclusive license expires (approved_at + 12 months). Null = non-exclusive (no defined expiry). */
    license_expires_at?: string | null;
}

export interface IBrandOpsContractClarification {
    _id: string;
    message: string;
    from_email: string;
    created_at: string;
    reply: string | null;
    replied_at: string | null;
    is_answered: boolean;
}

export interface IBrandOpsHomeStats {
    active_manager_count: number;
    live_contract_count: number;
    total_escrow_cents: number;
    currency: string;
    scheduled_post_count: number;
    next_scheduled_at: string | null;
    next_scheduled_platform: string | null;
    auto_reply_count: number;
}

export interface IBrandOpsState {
    homeStats: IBrandOpsHomeStats | null;
    fetchingHomeStats: boolean;
    access: IBrandOpsAccess | null;
    fetchingAccess: boolean;
    team: IBrandOpsTeamMember[];
    fetchingTeam: boolean;
    inviting: boolean;
    contracts: IBrandOpsContract[];
    fetchingContracts: boolean;
    activeContract: IBrandOpsContract | null;
    fetchingContract: boolean;
    mutatingContract: boolean;
    calendar: IBrandOpsCalendarItem[];
    fetchingCalendar: boolean;
    mutatingCalendar: boolean;
    settings: IBrandOpsSettings | null;
    fetchingSettings: boolean;
    knowledge: IBrandOpsKnowledgeDoc[];
    fetchingKnowledge: boolean;
    mutatingKnowledge: boolean;
    aiResult: IBrandOpsAiPlaygroundResult | null;
    aiBusy: boolean;
    inbox: IBrandOpsInboxItem[];
    fetchingInbox: boolean;
    inboxStatus: IBrandOpsInboxStatus | null;
    conversations: IBrandOpsConversation[];
    fetchingConversations: boolean;
    conversationMessages: IBrandOpsInboxMessage[];
    fetchingMessages: boolean;
    sendingMessage: boolean;
    ugcAssets: IBrandOpsUgcAsset[];
    fetchingUgcAssets: boolean;
    mutatingEscrow: boolean;
    downloadingPdf: boolean;
    error: IErrorType | null;
    /** Soft API unavailable (404) — show friendly empty, not crash */
    apiUnavailable: boolean;
    /** True while GET /brand-ops/team/mine is in flight */
    fetchingMyMemberships: boolean;
    /** True once GET /brand-ops/team/mine has completed at least once */
    myMembershipsFetched: boolean;
    /** The calling manager's own contract for this brand (null = no contract) */
    myContract: IBrandOpsContract | null;
    fetchingMyContract: boolean;
    automations: IBrandOpsAutomationRule[];
    fetchingAutomations: boolean;
    mutatingAutomation: boolean;
    clarifications: IBrandOpsContractClarification[];
    fetchingClarifications: boolean;
    replyingToClarification: boolean;
    pendingClarificationCount: number;
    pendingContractSignedCount: number;
    pendingContractDeclinedCount: number;
    pendingNewDmCount: number;
    lastNewDm: { ig_user_id: string; sender_id: string; message_id: string; text: string; timestamp: number } | null;
}

export type BrandOpsBrandPayload = { brandId: string; force?: boolean };

export type InviteBrandOpsTeamPayload = {
    brandId: string;
    email: string;
    role: BrandOpsRole;
    userId?: string;
    contract?: {
        fee: number;
        cadence: 'weekly' | 'monthly' | 'per_deliverable';
        currency?: string;
        title?: string;
        deliverables?: string;
        clearance_scopes?: string[];
        missed_post_threshold?: number;
        require_brand_approval?: boolean;
        duration_periods?: number;
    };
};

export type ContractReviewTokenPayload = { token: string };

export interface IContractReview {
    brand_name?: string;
    brand_logo?: string | null;
    manager_email?: string;
    title?: string | null;
    role?: string;
    fee?: number;
    currency?: string;
    cadence?: string;
    deliverables?: string | null;
    clearance_scopes?: string[];
    require_brand_approval?: boolean;
    invite_token?: string;
    legal_preview?: string | null;
}

export type UpdateBrandOpsTeamMemberPayload = {
    brandId: string;
    memberId: string;
    role?: BrandOpsRole;
    status?: string;
};

export type RemoveBrandOpsTeamMemberPayload = { brandId: string; memberId: string };

export type AcceptBrandOpsInvitePayload = { token?: string; id?: string; brandId?: string };

export type CreateBrandOpsContractPayload = {
    brandId: string;
    body: Partial<IBrandOpsContract> & {
        fee: number;
        currency: string;
        cadence: string;
        deliverables: string;
        manager_email: string;
    };
};

export type BrandOpsContractIdPayload = { brandId: string; contractId: string };
export type BrandOpsContractActionPayload = { brandId: string; contractId: string; reason?: string };

export type SignBrandOpsContractPayload = {
    brandId: string;
    contractId: string;
    typed_name: string;
    signature_data_url: string;
    affirmed: boolean;
};

export type CreateBrandOpsCalendarPayload = {
    brandId: string;
    body: Partial<IBrandOpsCalendarItem>;
};

export type UpdateBrandOpsCalendarPayload = {
    brandId: string;
    itemId: string;
    body: Partial<IBrandOpsCalendarItem>;
};

export type ApproveBrandOpsCalendarPayload = { brandId: string; itemId: string };

export type PublishBrandOpsCalendarPayload = { brandId: string; itemId: string };

export type UpdateBrandOpsSettingsPayload = { brandId: string; body: Partial<IBrandOpsSettings> };

export type AddBrandOpsKnowledgePayload = {
    brandId: string;
    body: { title: string; text_excerpt?: string; file_key?: string; public_url?: string; mime_type?: string };
};

export type RemoveBrandOpsKnowledgePayload = { brandId: string; docId: string };

export type BrandOpsAiPlaygroundPayload = {
    brandId: string;
    message: string;
    format?: 'plain' | 'instagram_dm';
};

export type BrandOpsEscrowPeriodPayload = {
    brandId: string;
    contractId: string;
    periodId: string;
};

export type BrandOpsAddStrikePayload = {
    brandId: string;
    contractId: string;
    reason: string;
};

export type BrandOpsConversationMessagesPayload = {
    brandId: string;
    conversationId: string;
};

export type BrandOpsSendInboxMessagePayload = {
    brandId: string;
    recipient_id: string;
    text: string;
};

export type BrandOpsUgcAssetsPayload = {
    brandId: string;
    campaignId?: string;
    force?: boolean;
};

export type UpsertBrandOpsAutomationPayload = {
    brandId: string;
    social_post_id: string;
    trigger_word: string;
    dm_message: string;
    public_reply_text?: string;
    enabled?: boolean;
};

export type ToggleBrandOpsAutomationPayload = {
    brandId: string;
    automationId: string;
    enabled: boolean;
};
